import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer" style={{ textAlign: "center" }}>
      <p>
        {/* Made with <span style={{ color: "red" }}>♥</span> by{" "} */}
        <p>&copy; 2025 Roshan Aale Magar. All rights reserved.</p>
        {/* <Link
          to="http://roshanaalemagar.com:3000"
          target="_blank"
          rel="noopener noreferrer"
        >
          Roshan Aale Magar
        </Link> */}
      </p>
    </footer>
  );
};

export default Footer;
